import React, { useState } from "react";

const StoryCard = ({
	image,
	title,
	buttonText,
	buttonPosition = "right", // or "left"
	onClick,
}) => {
	const [hovered, setHovered] = useState(false);

	return (
		<div
			className='relative w-full h-48 md:h-56 rounded shadow-lg overflow-hidden mb-8 cursor-pointer group transition-shadow duration-300 hover:shadow-2xl'
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			onClick={onClick}>
			{/* Background Image */}
			<img
				src={image}
				alt={title}
				className='absolute inset-0 w-full h-full object-cover'
			/>

			{/* Overlay for darkening image */}
			<div className='absolute inset-0 bg-black/10' />

			{/* Title (shows when not hovered) */}
			<div
				className={`absolute z-10 px-4 py-2 bg-white font-bold text-md md:text-md text-gray-900 rounded transition-all duration-300
          ${buttonPosition === "right" ? "left-4 bottom-4" : "left-4 top-4"}
          ${
						hovered
							? "opacity-0 translate-y-2 pointer-events-none"
							: "opacity-100"
					}
        `}>
				{title}
			</div>
			<button
				className={`absolute z-10 px-6 py-2 bg-blue-800 text-white font-semibold rounded-full shadow-lg transition-all duration-300
          ${buttonPosition === "right" ? "right-4 top-4" : "right-4 bottom-4"}
          ${
						!hovered
							? "opacity-100"
							: "opacity-0 translate-y-2 pointer-events-none"
					}
        `}>
				{buttonText}
			</button>

			{/* Button (shows on hover) */}
			<button
				className={`absolute z-10 px-6 py-2 bg-blue-800 text-white font-semibold rounded-full shadow-lg transition-all duration-300
          ${buttonPosition === "right" ? "right-4 bottom-4" : "left-4 bottom-4"}
          ${
						hovered
							? "opacity-100"
							: "opacity-0 translate-y-2 pointer-events-none"
					}
        `}>
				Continue
			</button>
		</div>
	);
};

export default StoryCard;
